<!-- START: pages/login-beta -->
<div class="cat__pages__login cat__pages__login--fullscreen">
    <div class="cat__pages__login__block cat__pages__login__block--extended">
        <div class="row">
            <div class="col-xl-12">
                <div class="cat__pages__login__block__inner">
                    <div class="cat__pages__login__block__form">
                        <h4 class="">
                            <div class="login-logo"></div>
                            <BR/><br/>
                            <strong>Sign in with your LLS ID </strong>
                            <!-- show the environment on login, mainly intended for the mobile app-->
                            <span class="env" *ngIf="hybridToolsService.isMobileApp() && environment">({{environment}})</span>
                        </h4>
                        <br/>

                        <ngb-alert id="loginerror" [hidden]="!errorMessage" type="danger" (close)="errorMessage = null">
                            {{ errorMessage }}
                        </ngb-alert>

                        <form #loginForm="ngForm"
                              (ngSubmit)="onSubmit()">
                            <div class="form-group">
                                <label class="form-label">Username</label>
                                <input class="form-control"
                                       [(ngModel)]="loginModel.username"
                                       required
                                       placeholder="Email or Username"
                                       name="username"
                                       #username="ngModel">
                                <div class="form-control-error" [hidden]="username.valid || (username.pristine && !loginForm.submitted)">
                                    <ul><li *ngIf="username?.errors?.required">Username is required.</li></ul>
                                </div>
                            </div>
                            <div class="form-group">
                                <label class="form-label">Password</label>
                                <input class="form-control password"
                                       [(ngModel)]="loginModel.password"
                                       required
                                       name="password"
                                       type="password"
                                       placeholder="Password"
                                       #password="ngModel">
                                <div class="form-control-error" [hidden]="password.valid || (password.pristine && !loginForm.submitted)">
                                    <ul><li *ngIf="password?.errors?.required">Password is required.</li></ul>
                                </div>
                            </div>
                            <div class="form-group">
                                <a (click)="forgotPassword()"
                                   class="pull-right text-primary">Forgot
                                    Password?</a>
                                <div class="checkbox">
                                    <label>
                                        <input type="checkbox"
                                               name="example6"
                                               [(ngModel)]="loginModel.rememberMe">
                                        Remember me
                                    </label>
                                </div>
                            </div>
                            <div class="form-actions" style="display: flex;">
                                <button type="submit" class="btn btn-login btn-primary mr-sm-3 mr-1">Sign In</button>
                                <span class="register-link">
                                    No account? <a href="https://www.lls.org/joinlls" target="_blank"
                                                   class="text-primary">Learn more</a> about how you can participate today!
                                </span>
                            </div>
                        </form>
                    </div>
                    <div class="cat__pages__reset__password__form hidden">
                    <h4 class="">
                            <div class="login-logo"></div>
                        </h4>
                        <br/><br/>
                      <form #resetPasswordForm="ngForm" (ngSubmit)="resetPassword()">
                        <div class="form-group">
                        <span>Username or E-mail associated with your account</span>
                        <input [(ngModel)]="resetPasswordModel.email" class="form-control width100"
                                required
                                placeholder="Email or Username"
                                name="Email"
                                pattern="^(['a-zA-Z0-9_\-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$"
                                #Email="ngModel">

                            <div class="form-control-error" [hidden]="Email.valid || (Email.pristine && !resetPasswordForm.submitted)">
                                <ul><li *ngIf="Email?.errors?.required">Email is required.</li></ul>
                                <ul><li *ngIf="Email?.errors?.pattern">Email is invalid.</li></ul>
                            </div>
                        </div>
                        <div class="form-group form-actions no-wrap">
                            <button type="button" (click)="backToLogin()" class="btn btn-outline-primary mr-sm-3 mr-1">
                                        Back to Log-in</button>
                            <button type="submit" class="btn btn-primary mr-sm-3 mr-1">
                                Recover Password</button>
                        </div>
                    </form>
                    <div class="reset-instructions">
                        <p><strong>We'll send you an email to the address above.</strong>
                        If you do not receive it please call us at 888-LLS-7177.
                            Monday - Friday 9:30 AM - 5:30 PM EST for assistance.
                        </p>
                    </div>
                    </div>
                    <div class="cat__pages__update__password__form hidden">
                        <form #updatePasswordForm="ngForm" (ngSubmit)="updatePassword()">
                            <span>Please enter your new password:</span> <!-- After "Forgot Password" -->
                            <!--
                            Below the maxlength attribute is 129, but the pattern validation length is 128.
                            This is to avoid having the user paste a 128+ char password, which then gets silently truncated and submitted successfully.
                            In this (unlikely) case, the user would not know that their password has been truncated and wouldn't be able to login.
                            Pattern matches FRT server validation and any changes should be coordinated.
                            -->
                            <div class="form-group">
                                <input [(ngModel)]="updatePasswordModel.password" class="form-control width100"
                                       required
                                       pattern="^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!-/:-@\[-`\{-~}€£¥¢])[a-zA-Z0-9!-/:-@\[-`\{-~}€£¥¢]{8,128}$"
                                       maxlength="129"
                                       type="password"
                                       placeholder="New password"
                                       name="Password"
                                       #Password="ngModel">
                                <div class="form-control-error" [hidden]="Password.valid || (Password.pristine && !updatePasswordForm.submitted)">
                                    <ul><li *ngIf="Password?.errors?.required">Required</li></ul>
                                    <ul><li *ngIf="Password?.errors?.pattern">Password should be 8 or more characters with at least 1 number, 1 lowercase letter, 1 uppercase letter, and 1 special character</li></ul>
                                </div>
                            </div>
                            <div class="form-group">
                                <input [(ngModel)]="updatePasswordModel.confirm" class="form-control width100"
                                       type="password"
                                       placeholder="Confirm password"
                                       name="Confirm"
                                       #Confirm="ngModel">
                                <div class="form-control-error" [hidden]="Confirm.valid || (Confirm.pristine && !updatePasswordForm.submitted)">
                                    <ul><li *ngIf="Confirm?.errors?.matchError">Passwords must match!</li></ul>
                                </div>
                            </div>
                            <div class="form-group form-actions no-wrap">
                                <button type="submit" class="btn btn-primary mr-sm-3 mr-1">
                                    Submit Password</button>
                            </div>
                        </form>
                    </div>

                    <div class="cat__pages__use__another mt-2" *ngIf="!hybridToolsService.allowThirdPartyLogin();else thirdPartyLogin">
                        <!-- Hiding text due to apple being apple.  If users are using this link, then we'll direct them to a help screen instead. -->
                        <!-- h4 class="text-black">
                            <strong>Or click <a href="{{ fundraiseUrl }}">here</a> for other sign in options</strong>
                        </h4 -->
                    </div>
                    <ng-template #thirdPartyLogin>
                        <div class="cat__pages__use__another mt-2">
                            <h4 class="text-black"><strong>
                                Or use another service to sign in 
                            </strong></h4>
                            <div class="mt-2">
                                <div (click)="socialLogin('facebook')" class="btn btn-icon ui-facebook-login mr-2" style="display: inline-block; vertical-align: top; padding: 8px 12px!important">
                                    <i class="icmn-facebook"></i>
                                </div>
                                <div *ngIf="hybridToolsService.isMobileApp();else googleWebLogin"(click)="socialLogin('google')" class="btn btn-icon ui-google-login" style="display: inline-block; vertical-align: top; padding: 8px 12px!important">
                                    <i class="icmn-google"></i>
                                </div>
                                <ng-template #googleWebLogin>
                                    <div style="display: inline-block" id="googleSignInContainer">

                                    </div>
                                </ng-template>
                            </div>
                        </div>
                    </ng-template>

                    <div class="cat__pages__login__block__sidebar">
                        <h4 class="cat__pages__login__block__sidebar__title">
                            United in the fight to end cancer.
                        </h4>
                        <div class="cat__pages__login__block__sidebar__item">
                            <p>
                                LLS does more to advance science and support patients than any other cancer organization.
                                Walk, run, hike, swim, bike, sail, network, volunteer, or start your own campaign.
                                You'll be part of a growing team of passionate, caring people determined to make
                                someday, today.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="cat__pages__login__footer text-center">
        <ul class="list-unstyled list-inline">
            <!-- Note: these same links exist in footer.component.html -->
            <li class="list-inline-item">
                <a (click)="hybridToolsService.openExternalLink('https://www.lls.org/lls-us-hq/article/refund-policy')"
                   >Refund</a>
            </li>
            <li class="list-inline-item">
                <a (click)="hybridToolsService.openExternalLink('https://www.lls.org/lls-us-hq/article/privacy-policy')"
                   >Privacy</a>
            </li>
            <li class="list-inline-item">
                <a (click)="hybridToolsService.openExternalLink('https://www.lls.org/lls-us-hq/article/copyright')"
                   >Copyright</a>
            </li>
            <li class="list-inline-item">
                <a (click)="hybridToolsService.openExternalLink('https://www.lls.org/lls-us-hq/article/security')"
                   >Security</a>
            </li>
            <li class="list-inline-item">
                <a (click)="hybridToolsService.openExternalLink('https://www.lls.org/lls-us-hq/article/disclaimer')"
                   >Disclaimer</a>
            </li>
        </ul>
    </div>
</div>

<!-- IE Message for unsupported Social Login -->
<div class="ie-modal modal" tabindex="-1" role="dialog" style="z-index: 20000; background: #00000075;">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Unsupported Browser</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <p>Social Media login is no longer supported on Internet Explorer. Please install another web browser.</p>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
        </div>
      </div>
    </div>
  </div>

<!-- END: pages/login-beta -->
